import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Lab, PlusIcon } from '@images';
import { patientRadiologistActions, consultationActions } from '@actions';
import { Breadcrumb, H1, Add, Pagination, StateCard, Modal } from '@utils';
import { Container, RequestMedicalRecordForm } from '@components';
import styled from '@emotion/styled/macro';

const XRaysWrapper = styled.div`
  h1 {
    font-size: 30px;
  }
  a {
    font-family: AvenirNext;
    font-size: 14px;
    font-weight: 500;
    color: #9298ac;
  }
  .ant-breadcrumb-separator {
    margin-right: 5px;
    color: #9298ac;
  }
  .add {
    margin-bottom: 25px;
  }
  .pagination {
    max-width: 780px;
    margin-left: 0;
  }
  .request {
    display: block;
    margin: 15px 0;
    color: #5cb3db;
    img {
      margin-right: 10px;
      width: 25px;
      height: 25px;
      margin-top: 20px;
      position: relative;
      top: -11px;
    }
  }
`;

class XRays extends Component {
  componentDidMount() {
    const {
      getXRays,
      match: {
        params: { patientId },
      },
      getSharedXRays,
    } = this.props;
    const sharedToken = new URLSearchParams(this.props.location.search).get(
      'sharedToken'
    );
    if (patientId && !sharedToken) {
      getSharedXRays(patientId);
    } else if (patientId && sharedToken) {
      getSharedXRays(patientId, sharedToken);
    } else {
      getXRays();
    }
  }
  state = {
    showModal: false,
  };

  handelCloseModal = () => {
    this.setState({ showModal: false });
  };

  handelShowModal = () => {
    this.setState({ showModal: true });
  };

  setPage = page => {
    const {
      getXRays,
      match: {
        params: { patientId },
      },
      getSharedXRays,
    } = this.props;
    const sharedToken = new URLSearchParams(this.props.location.search).get(
      'sharedToken'
    );
    if (patientId && !sharedToken) {
      getSharedXRays(patientId, null, page);
    } else if (patientId && sharedToken) {
      getSharedXRays(patientId, sharedToken, page);
    } else {
      getXRays(page);
    }
  };

  render() {
    const {
      xrays,
      match: {
        params: { consiltionId, patientId },
      },
      requestScan,
    } = this.props;
    const { showModal } = this.state;
    const userType = localStorage.getItem('userType');
    const sharedToken = new URLSearchParams(this.props.location.search).get(
      'sharedToken'
    );
    const RequestConsultation = new URLSearchParams(
      this.props.location.search
    ).get('RequestConsultation');

    return (
      <Container>
        <XRaysWrapper>
          <Breadcrumb
            links={[{ item: 'Medical Record ', url: '/#MedicalRecord' }]}
          />
          <H1>XRay</H1>
          {userType === 'consultant' && !sharedToken && (
            <Link
              className="request"
              to="#!"
              onClick={() => this.handelShowModal()}
            >
              <img src={PlusIcon} alt="Plus" />
              Request XRay
            </Link>
          )}
          {userType === 'patient' && !sharedToken && (
            <Add
              to={`/xrays/new${
                RequestConsultation ? '?RequestConsultation=1' : ''
              }`}
            />
          )}

          {xrays &&
            xrays.data.map(report => (
              <StateCard
                to={
                  userType === 'consultant'
                    ? `/consultation/${consiltionId}/xray/${report.id}`
                    : `/xray/${report.id}`
                }
                key={report.createdAt}
                title={report.title}
                time={report.createdAt}
                patientId={patientId}
              />
            ))}
          {xrays && xrays.meta.total > xrays.meta.per_page && (
            <Pagination
              pageSize={xrays.meta.per_page}
              total={xrays.meta.total}
              setPage={this.setPage}
            />
          )}
          <Modal
            title={'Request XRay'}
            image={Lab}
            showModal={showModal}
            handelCloseModal={this.handelCloseModal}
          >
            <>
              <RequestMedicalRecordForm
                requestScan={requestScan}
                scanType={'radiology-xray'}
                consultationId={Number(consiltionId)}
                handelCloseModal={this.handelCloseModal}
              />
            </>
          </Modal>
        </XRaysWrapper>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  const {
    xray: { xrays },
  } = state.radiologist;
  return {
    xrays,
  };
};

const mapDispatchToProps = dispatch => ({
  getXRays: (page = null) => dispatch(patientRadiologistActions.getXRays(page)),
  getSharedXRays: (patientId, sharedToken, page = null) =>
    dispatch(
      patientRadiologistActions.getSharedXRays(patientId, sharedToken, page)
    ),
  requestScan: ({ scanType, id, title, body }) =>
    dispatch(consultationActions.requestScan({ scanType, id, title, body })),
});

XRays.propTypes = {
  getXRays: PropTypes.func.isRequired,
  xrays: PropTypes.object,
  match: PropTypes.object.isRequired,
  getSharedXRays: PropTypes.func.isRequired,
  requestScan: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(XRays);
